import React from "react"
import { concatStrings, conditionalLinkTarget } from "../utilities"
import DfbSymbol from "./dfb_symbol"
import { withPrefix } from "gatsby"

const DfbButton = (props) => {
  const TagName = `${props.tagName.toLowerCase()}`
  const anchorLink = TagName === "a" ? { href: withPrefix(props.link) } : {}
  const buttonType = TagName === "button" ? { type: props.type } : {}
  const target = conditionalLinkTarget(props.link, props.link_obj)
  const disabled = props.disabled ? { disabled: true } : {}
  const style = props.style ? { style: props.style } : {}
  const errorClass = props.error ? "is-invalid" : ""
  const iconOnlyClass = props.icon_type && !props.text ? "dfb-Button--icon" : ""
  const secondaryClass = props.secondary ? "dfb-Button--secondary" : ""
  const anchorTitle =
    props.title && props.title.length > 0 ? { title: props.title } : {}
  const testid = props.testid ? props.testid : null
  return (
    <TagName
      onClick={props.onClick}
      {...anchorLink}
      {...anchorTitle}
      {...buttonType}
      {...disabled}
      {...style}
      {...target}
      className={concatStrings(
        "dfb-Button",
        secondaryClass,
        iconOnlyClass,
        errorClass,
        props.add_class
      )}
      data-testid={testid}
    >
      {props.text && props.text.length > 0 && (
        <span className="dfb-Button-label">{props.text}</span>
      )}
      {props.icon_type && props.icon_type.length > 0 && (
        <span className="dfb-Button-icon">
          <DfbSymbol icon_type={props.icon_type} />
        </span>
      )}
    </TagName>
  )
  // if (props.button_type === "link") {
  //   return (
  //     <a onClick={props.onClick} className={concatStrings('dfb-Button', props.add_class)} href={props.link} title={props.button_text}>
  //       <span className="dfb-Button-label">{props.button_text}</span>
  //     </a>
  //   );
  // } else if (props.button_type === "disabled") {
  //   return (
  //     <button
  //       onClick={props.onClick}
  //       className={concatStrings('dfb-Button dfb-Button--disabled is-disabled', props.add_class)}
  //       type="button"
  //       disabled
  //       data-a="a"
  //       data-b="b"
  //     >
  //       <span className="dfb-Button-label">{props.button_text}</span>
  //     </button>
  //   );
  // } else if (props.button_type === "fake") {
  //   return (
  //     <div className={concatStrings('dfb-Button dfb-Button--fake', props.add_class)}>
  //       <span className="dfb-Button-label">{props.button_text}</span>
  //     </div>
  //   );
  // } else if (props.button_type === "icon") {
  //   return (
  //     <button onClick={props.onClick} className={concatStrings('dfb-Button dfb-Button--icon', props.add_class)} type="submit" title={props.title}>
  //       <DfbSymbol icon_type={props.icon_type} />
  //     </button>
  //   );
  // } else if (props.button_type === "icon_link") {
  //   return (
  //     <a onClick={props.onClick} className={concatStrings('dfb-Button dfb-Button--iconLink', props.add_class)} href={props.link}>
  //       <DfbSymbol icon_type={props.icon_type} />
  //     </a>
  //   );
  // } else {
  //   return (
  //     <button onClick={props.onClick} className={concatStrings('dfb-Button', props.add_class)} type="submit">
  //       <span className="dfb-Button-label">{props.button_text}</span>
  //     </button>
  //   );
  // }
}

DfbButton.defaultProps = {
  tagName: "button",
  type: "submit",
  secondary: false,
  disabled: false,
  error: false,
}

export default DfbButton
